import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import 'shared/styles/table.style.less';
import {Button} from 'antd';
import {IoReload} from 'react-icons/all';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import RequestTable from './RequestTable';
import {RequestContext} from './RequestContext';
import RequestEditor from './RequestEditor';

const RequestList = () => {
  const intl = useIntl();

  const requestContext = useContext(RequestContext);
  const {setSelectedRequest, setEditing, setReloading} = requestContext;

  const onAdd = () => {
    setSelectedRequest({});
    setEditing(true);
  };

  return (
    <>
      <AppPageMetadata title={intl.messages['request.list']} />
      <AppsContainer
        title={intl.messages['request.list']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button type='primary' onClick={() => onAdd()}>
                {intl.messages['common.add']}
              </Button>
            </div>
            <div className='customer-header-right'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoReload />}
                onClick={() => setReloading(true)}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <RequestTable />
        </AppsContent>

        <RequestEditor />
      </AppsContainer>
    </>
  );
};

export default RequestList;
